export default function () {
  return {
    greatGrandmothersExist: false,
    greatGrandmotherPairs: 0,
    greatGrandmotherFirstAlive: 0,
    greatGrandmotherSecondAlive: 0,
  };
}
